// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"645":"440e550b","796":"c2251f2c"}[chunkId] + ".chunk.css";
};